<div class="confirm-card">
  <div class="confirm-card__icon" [class.confirm-card__icon--primary]="tone === 'primary'">
    <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2"
      stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <ng-container *ngIf="icon === 'trash'; else exitIcon">
        <polyline points="3 6 5 6 21 6" />
        <path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6" />
        <path d="M10 11v6" />
        <path d="M14 11v6" />
        <path d="M9 6V4a2 2 0 012-2h2a2 2 0 012 2v2" />
      </ng-container>
      <ng-template #exitIcon>
        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
        <polyline points="16 17 21 12 16 7" />
        <line x1="21" y1="12" x2="9" y2="12" />
      </ng-template>
    </svg>
  </div>
  <h2 class="confirm-card__title">{{ title }}</h2>
  <p class="confirm-card__message" *ngIf="message">{{ message }}</p>
  <div class="confirm-card__actions">
    <button type="button" class="ui-btn ui-btn--secondary" (click)="cancel.emit()" [disabled]="loading">
      {{ cancelLabel }}
    </button>
    <button type="button" class="ui-btn" [ngClass]="tone === 'danger' ? 'ui-btn--danger' : 'ui-btn--primary'"
      (click)="confirm.emit()" [disabled]="loading">
      {{ loading ? loadingLabel : confirmLabel }}
    </button>
  </div>
</div>
